// extracted by mini-css-extract-plugin
export default {"foundation":"UsefulQualitiesnSkills_foundation__4QmN6","container":"UsefulQualitiesnSkills_container__z41--","boxs":"UsefulQualitiesnSkills_boxs__zeGZo"};